import React, { useEffect, useState } from "react";
import Select from "react-select";

export default function SearchBy(props) {
  const [searchType, setSearchType] = useState();

  useEffect(() => {
    if (props.searchType) {
      setSearchType(
        props.options.filter((s) => s.value === props.searchType)[0]
      );
    } else {
      setSearchType(props.placeholder);
    }
  }, [props.searchType]);

  return (
    <Select
      value={searchType && searchType}
      // value={
      //   searchType
      //     ? searchType
      //     : props.options.filter((s) => s.value === props.searchType)[0]
      // }
      defaultValue={searchType}
      onChange={(searchType) => {
        setSearchType(searchType);
        props.changeSearchType(searchType);
      }}
      placeholder={props.placeholder}
      className="search-by-select desktop"
      options={props.options}
      theme={(theme) => ({
        ...theme,
        borderRadius: 0,
        colors: {
          ...theme.colors,
          primary25: "#FBCD4E",
          primary: "black",
        },
      })}
    />
  );
}
